export default {
    "permission_to_entity_matrix": {
        "see": {
            "card": "comment.type_card_see",
            "card_element": "comment.type_element_see"
        }
    },
    "attachments": {
        "extensions": [
            "txt",
            "docx",
            "doc",
            "xls",
            "xlsx",
            "rar",
            "zip",
            "jpg",
            "jpeg",
            "png",
            "pdf"
        ]
    },
    "is_auto_send_comment_on_blur": false
}